import React from 'react'
import { useParam } from '../../../infra/libs/react-location-hooks/routerHooks'
import { BotaoAdicionarRemoverListaLeituraContainer } from './BotaoAdicionarRemoverListaLeituraContainer'

export function BotaoAdicionarRemoverListaLeituraPelaPaginaDoFatoContainer() {
  const fatoId = useParam('id')
  return <BotaoAdicionarRemoverListaLeituraContainer fatoId={fatoId} />
}
